export default __webpack_public_path__ + "static/media/3233 spice rack A side.6b74ecab.png";